function e_track() {
	// return;
	//social tracking
	var se = sui_sc.events;
	var lt = sui_sc.linkTypes;
	var bpn = "%btnTitle%";
	var social_map = {
		"twitter" : se.twitterShare,
		"newsletter" : se.unclassSocial,
		"instagram" : se.unclassSocial,
		"facebook" : se.unclassSocial,
		"fb" : se.unclassSocial,
		"youtube" : se.unclassSocial,
		"blog" : se.unclassSocial,
		"gplus" : se.googlePlus
	};
	//external methods can be access by adding them to this object
	var external = {};
	$("#connect").find("a").each(function() {

		$(this).click(function(e) {
			// e.preventDefault();
			var label = sui_sc.prepText($(this).data("event_track"));
			sui_sc.track({
				a : this,
				kind : "o",
				vars : ["events", "prop49", "eVar49"],
				title : "connect " + label,
				props : {
					49 : "box:social:" + label + ":" + bpn
				},
				evars : {
					49 : "D=c49"
				},

				events : [se.event66]
			});
		});
	});
	//nav tracking
	/*
	$( ".header-nav, #userMenuTop, #searchHolder, .user-logged-out" ).find("a").each(function() {

		$(this).click(function(e) {
			var t = $(this);
			var label = t.data("event_track");
			var track = 1;
			// console.log(t.data("clicked"));
			if (t.data("clicked") == true) {
				return;
			}
			// console.log("clicked");
			if ( typeof (label) == "undefined") {
				//we don't have tracking, therefore we need to add it
				//we'll look to the classes, typically they will be lithium, so
				var cl = t.attr("class");
				// console.log(cl);
				//we can now search cl for the class names that we're interested in
				var lookups = {
					"login-link" : {
						"t" : 1,
						"label": "sign in"
					},
					"registration-link" : {
						"t" : 1,
						"label": "register"
					},
					"logout-link" : {
						"t" : 1,
						"label": "sign out"
					}
				};

				for (var k in lookups) {
					if (cl && cl.search(k) != -1) {
						label = k;

						//if(lookups[k].hasOwnProperty("label")){
						if(typeof(lookups[k].label) != "undefined"){

							label = lookups[k].label;
						}
						track = lookups[k].t;
						break;
					}
				}
			}
			// console.log(label);
			if (track) {
				var obj = {
					a : this,
					title : label,
					vars : ["events", "prop49", "eVar49"],
					props : {
						49 : "link:"+sui_sc.prepText(label)+":nav:" + bpn
					},
					evars : {
						49 : "D=c49"
					},

					events : [se.event66]
				};

				sui_sc.track(obj);
			}

		});
	});
	$(".catRow").each(function() {

		$(this).click(function(e) {
			var t = $(this);
			var label = sui_sc.prepText(sui_sc.lookupPreferredLabelFromId(t.data("event_track")));
			var obj = {
				a : this,
				title : label,
				vars : ["events", "prop49", "eVar49"],
				props : {
					49 : "link:board_list:" + label + ":" + bpn
				},
				evars : {
					49 : "D=c49"
				},
				events : [se.event66]
			};
			sui_sc.track(obj);
		});
	});
	*/
	function trackSignIn(ele, btn_location) {
		sui_sc.track({
			a : ele,
			title : "login",
			vars : ["events", "prop49", "eVar49"],
			props : {
				49 : "button:sign in:" + btn_location + ":" + bpn
			},
			evars : {
				49 : "D=c49"
			},
			events : [se.event66]
		});
	};
	external.trackSignIn = function(ele,btn_location){
		return trackSignIn(ele,btn_location);
	};
	function trackRegister(ele, btn_location) {
		sui_sc.track({
			a : ele,
			title : "register",
			vars : ["events", "prop49", "eVar49"],
			props : {
				49 : "button:register:" + btn_location + ":" + bpn
			},
			evars : {
				49 : "D=c49"
			},
			events : [se.event66]
		});
	};
	/*
	$("#signupInner").find(".login-link").click(function(e) {
		trackSignIn(e, "welcome-bar");
	});
	// $("#main-nav").find(".login-link").click(function(e) {
	// trackSignIn(e, "nav-bar");
	// });
	$("#signupInner").find(".registration-link").click(function(e) {
		trackRegister(e, "welcome-bar");
	});
	*/
	// $("#main-nav").find(".registration-link").click(function(e) {
	// trackRegister(e, "nav-bar");
	// });
	$(".mashA").click(function(e) {
		var t = $(this);
		var label = sui_sc.prepText(t.find("h1").text());
		sui_sc.track({
			a : this,
			title : label,
			vars : ["events", "prop49", "eVar49"],
			props : {
				49 : "link:mash" + t.data("index") + ":" + label + ":" + bpn
			},
			evars : {
				49 : "D=c49"
			},
			events : [se.event66]
		});
	});
	$("#statsCol").children("a").click(function(e) {
		var label = "stats link";
		sui_sc.track({
			a : this,
			title : label,
			vars : ["events", "prop49", "eVar49"],
			props : {
				49 : "link:stats:" + label + ":" + bpn
			},
			evars : {
				49 : "D=c49"
			},
			events : [se.event66]
		});
	});
	$("#moreCommunities").find("a").click(function(e) {
		var t = $(this);
		var label = sui_sc.prepText(t.text());
		sui_sc.track({
			a : this,
			title : label,
			vars : ["events", "prop49", "eVar49"],
			props : {
				49 : "link:communities:" + label + ":" + bpn
			},
			evars : {
				49 : "D=c49"
			},
			events : [se.event66]
		});
	});

	function labelBoardTracking(){
		var types = {
			other_label: {"target":"labelList","title_holder":"other-board-title"},
			other_board: {"target":"otherBoardsList","title_holder":"other-board-title"}
		};
		for(var k in types){
			// console.log(types[k].target);
			$("."+types[k].target).find("a").each(function(){

				var t = $(this);
				// console.log(t);
				t.data("other_type",k);
				t.data("event_track",t.children("."+types[k].title_holder).text());
				t.click(function(){
					var label = t.data("event_track");
					//we want to translate board links to english
					var cur_type = t.data("other_type");
					if(cur_type == "other_board"){
						//we want to get the id
						var split_url = t.attr("href").split("/");
						var board_id = split_url[split_url.length-1];
						var trans_bid = sui_sc.prepText(sui_sc.lookupPreferredLabelFromId(board_id));
						if(trans_bid != board_id){
							label = trans_bid;
						}
					}
					sui_sc.track({
						a : this,
						title : label,
						vars : ["events", "prop49", "eVar49"],
						props : {
							49 : "link:"+cur_type+":" + sui_sc.prepText(label) + ":" + bpn
						},
						evars : {
							49 : "D=c49"
						},
						events : [se.event66]
					});
				});
			});
		}
	}
	labelBoardTracking();
	external.bannerImpression = function(siteCatObject){
		if(typeof(ad_tracking) == "undefined"){
			return;
		}
		// if (ad_tracking.type != "ad") {
			// return false;
		// }
		//we have a banner, lets track it
		var label = sui_sc.prepText(ad_tracking.banner_id) + ":" + bpn;
		label = label.replace(bpn,sui_sc.getButtonPageName());

		siteCatObject.list1 = label;
		siteCatObject.events = siteCatObject.events + ',' + sui_sc.events.AdorLinkImpression;
        siteCatObject.linkTrackVars = "events,list1,prop75,eVar75,prop2,eVar2";
		bannerTracking();
	};
	external.detectRussianFix = function(){
		setTimeout(function(){
			var styles = $("head").find("style");
			if(styles.length > 0){
				if($(styles[0]).html().search("lia") != -1){
					var obj = {
						a : true,
						title : "ru-fix",
						vars : ["prop58", "eVar58"],
						props : {
							58 : "ru-fix:" + bpn
						},
						evars : {
							58 : "D=c58"
						}

					};

					sui_sc.track(obj);
				}

			}
		},300);

	};
	function bannerTracking() {
		if(typeof(ad_tracking) == "undefined"){
			return;
		}
		var label = sui_sc.prepText(ad_tracking.banner_id) + ":" + bpn;
		// console.log(label,sui_sc,label.replace(bpn,sui_sc.getButtonPageName()));
				// console.log(label,"bpn: "+bpn,sui_sc.getButtonPageName());
//
		label = label.replace(bpn,sui_sc.getButtonPageName());

		if ((ad_tracking.link != "") && (ad_tracking.has_text == false)) {
			$("#theHero").click(function() {
				sui_sc.track({
					a : true,
					title : label,
					list1 : [label],
					vars : ["events", "prop41", "eVar41","list1"],
					props : {
						41 : label
					},
					evars : {
						41 : "D=c41"
					},
					events : [se.AdorLinkClickThrough]
				});
				//make the link, new window/tab
				window.open(ad_tracking.link, '_blank');
			});
		}
		$(".theHeroLink").click(function() {
			sui_sc.track({
				a : true,
				title : label,
				list1 : [label],
				vars : ["events", "prop41", "eVar41","list1"],
				props : {
					41 : label
				},
				evars : {
					41 : "D=c41"
				},
				events : [se.AdorLinkClickThrough]
			});
		});
	}


	return external;
};
//event_tracking contains the external methods of this object
var event_tracking = new e_track();
